import { getDocs, serverTimestamp } from 'firebase/firestore';
import React, { useContext, useEffect } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import styled from 'styled-components';

import { Context } from '../../index';
import ChatList from '../Chat/components/ChatList';
import Gallery from '../Chat/components/Gallery';
import MessageInput from '../Chat/components/MessageInput';
import MessageListBody from '../Chat/components/MessageListBody';
import useGalleryControls from '../Chat/hooks/useGalleryControls';
import useUsername from '../Chat/hooks/useUsername';

const ChatListSider = styled.div`
  display: flex;
  flex-direction: column;
  width: 390px;
  height: calc(100vh - 64px);
  border-right: 1px solid #d7def3;
`;

const MessageList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: calc(100vh - 64px);
  transition: all 0.3s;
`;

const SupportClient = () => {
  const { auth, firestore } = useContext(Context);
  const user = auth.currentUser;
  const userId = user?.uid;
  const userName = useUsername(userId);
  const { isGalleryVisible, showGallery, closeGallery, galleryImagePath } = useGalleryControls();

  const [supportChatSnapshot, loading] = useCollection(
    firestore
      .collection('chat_rooms')
      .where('user_ids', 'array-contains', userId)
      .where('room_type', '==', 1),
  );
  const supportChats = supportChatSnapshot?.docs?.map((item) => ({
    id: item.id,
    data: {
      ...item.data(),
    },
  }));
  const supportChatId = supportChats?.[0]?.id;

  useEffect(() => {
    const checkSupportChat = async () => {
      if (supportChats?.length === 0 && !loading) {
        const supportIdsSnapshot = await getDocs(firestore.collection('support_ids'));
        const supportIds = supportIdsSnapshot.docs.map((item) => item.data()?.support_id);
        // eslint-disable-next-line camelcase
        const last_msg_epoch = serverTimestamp();
        firestore.collection('chat_rooms').add({
          last_msg: '',
          // eslint-disable-next-line camelcase
          last_msg_epoch,
          last_msg_sender: '',
          last_msg_type: 0,
          room_avatar: '',
          room_name: userName,
          room_type: 1,
          user_ids: [...supportIds, userId],
        });
      }
    };
    checkSupportChat();
  }, [supportChats]);

  return (
    <>
      <ChatListSider>
        <ChatList isSupportChat chatRooms={[]} activeChat={supportChatId} />
      </ChatListSider>
      <MessageList>
        <MessageListBody
          activeChat={supportChatId}
          userId={userId}
          isClientSupportChat
          isSupportChat
          showGallery={showGallery}
        />
        <MessageInput activeChat={supportChatId} isSupportChat userId={userId} />
      </MessageList>
      <Gallery
        galleryImagePath={galleryImagePath}
        isGalleryVisible={isGalleryVisible}
        closeGallery={closeGallery}
      />
    </>
  );
};

export default SupportClient;
